import Vue from 'vue'
import Router from 'vue-router'
import {router} from './generator'

Vue.use(Router)

// your operation to Router here

export default router
